module.exports = __webpack_public_path__ + "img/defaultProductImg_YSL.e47fd78a.png";